import { ExperienceData, CONSUMER, ENTERPRISE } from './api'

const SUPPORTED_EXPERIENCES = [CONSUMER, ENTERPRISE]

export type Experience = {
  isConsumer: boolean
  isEnterprise: boolean
  isSingleClass: boolean
  isUnsupported: boolean

  isBookmarksEnabled: boolean
  isMyListEnabled: boolean
  isMyProgressEnabled: boolean
  isShareThisTrailerEnabled: boolean
  isShareLessonEnabled: boolean
  isNotesEnabled: boolean
}

const defaultExperience = {
  isConsumer: false,
  isEnterprise: false,
  isSingleClass: false,
  isUnsupported: false,

  isBookmarksEnabled: false,
  isMyListEnabled: false,
  isMyProgressEnabled: false,
  isShareThisTrailerEnabled: false,
  isShareLessonEnabled: false,
  isNotesEnabled: false,
}

type FormatExperience = (data?: ExperienceData) => Experience
const formatExperience: FormatExperience = (data) => {
  if (!data) return defaultExperience

  const {
    name,
    bookmarks,
    myList,
    myProgress,
    notes,
    shareThisTrailer,
    shareLesson,
    singleClassUser,
  } = data

  const isConsumer = name === CONSUMER && !singleClassUser
  const isEnterprise = name === ENTERPRISE
  const isUnsupported = !SUPPORTED_EXPERIENCES.includes(name)

  return {
    isConsumer,
    isEnterprise,
    isSingleClass: singleClassUser,
    isUnsupported,

    isBookmarksEnabled: bookmarks,
    isMyListEnabled: myList,
    isMyProgressEnabled: myProgress,
    isShareThisTrailerEnabled: shareThisTrailer,
    isShareLessonEnabled: shareLesson,
    isNotesEnabled: notes,
  }
}

export default formatExperience
